import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService, AuthToken } from 'src/app/services/auth.service';
import { AvailableApplication } from 'src/app/services/environment.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-user-companies-list',
  templateUrl: './user-companies-list.component.html',
  styleUrls: ['./user-companies-list.component.scss'],
})
export class UserCompaniesListComponent implements OnInit {
  userCompanies: any = [];
  filteredCompanies: any = [];
  isLoading: boolean = false;
  email: string = '';

  constructor(
    private readonly _route: ActivatedRoute,
    private readonly _authService: AuthService
  ) {
    this.userCompanies = this._authService.userCompanies
      .filter((res) => res.isHidden !== true)
      .sort((a, b) => Number(b.isPinned) - Number(a.isPinned));
    this.filteredCompanies = [...this.userCompanies];
  }

  ngOnInit() {
    this.email = this._route.snapshot.queryParams['email'];
    this._authService.captureDeepLinkReturnUrl(
      this._route.snapshot.queryParams['returnUrl']
    );
    this._authService.capturePostAuthApp(
      this._route.snapshot.queryParams['app']
    );
  }

  filterCompanyByName(evt: any) {
    const searchString = (evt.target as HTMLInputElement).value;
    this.filteredCompanies = this.userCompanies.filter(
      (uc: any) =>
        !searchString ||
        uc.company.name.toLowerCase().includes(searchString.toLowerCase())
    );
  }

  companySelected(userId: string, selectedCompany: string) {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this._authService.getAuthTokenForCompany(userId, selectedCompany).subscribe({
      next: (token) => {
        this._authService.getProductNamesWithLicenses().subscribe({
          next: (availableProducts) => {
            const appQueryParam = this._authService.resolvePostAuthApp();
            this._authService.appBasedRedirection(
              availableProducts,
              token,
              appQueryParam
            );
          },
          error: (err) => {
            console.log(err);
            const appQueryParam = this._authService.resolvePostAuthApp();
            this._authService.tryPostAuthAppFallback(token, appQueryParam);
          },
        });
      },
      error: (err) => {
        this.isLoading = false;
        console.error(err);
      },
    });
  }

  pinOrHideCompany(selectedUserCompany: any) {
    const request = this.createRequestPayload(selectedUserCompany);
    this._authService.hideOrPinCompany(request).subscribe({
      next: (res) => {
        console.log(res);
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  onPinClick(selectedUserCompany: any) {
    selectedUserCompany.isPinned = !selectedUserCompany.isPinned;
    this.pinOrHideCompany(selectedUserCompany);
  }

  onHideClick(selectedUserCompany: any) {
    selectedUserCompany.isHidden = true;
    this.pinOrHideCompany(selectedUserCompany);
  }

  createRequestPayload(selectedUserCompany: any) {
    return {
      userId: selectedUserCompany.userId,
      companyId: selectedUserCompany.company.id,
      isHidden: selectedUserCompany.isHidden,
      isPinned: selectedUserCompany.isPinned,
    };
  }
}
